
const firebaseConfig = {

    apiKey: "AIzaSyB9TCniHzZNQlw4IpRN3vVL8dIABHpIfjk",
  
    authDomain: "owncrypto-8cdd6.firebaseapp.com",
  
    projectId: "owncrypto-8cdd6",
  
    storageBucket: "owncrypto-8cdd6.appspot.com",
  
    messagingSenderId: "643395700731",
  
    appId: "1:643395700731:web:2e90f181eab6ef54d8ad5e"
  
  };
 
export default firebaseConfig;